module.exports = __webpack_public_path__ + "static/img/co2.4187dd07.jpg";